export const classes = {
  wrapper: 'relative size-full overflow-hidden',
};
